"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assets = void 0;
class Assets {
    constructor() {
        this._internalAssets = {
            noImage: undefined,
            pointsEarnedImg: undefined,
            noFeaturedImg: undefined,
            facebookLogo: undefined,
            instagramLogo: undefined,
            twitterLogo: undefined,
            rewardDownloadLogo: undefined,
            rewardRedeemLogo: undefined,
            kenoHotNumberImg: undefined,
            kenoColdNumberImg: undefined,
            playLogo: undefined,
            preAssignedPointsImg: undefined,
            bonusIcon: undefined,
            correctIcon: undefined,
            incorrectIcon: undefined,
            activeLegendImg: undefined,
            endedLegendImg: undefined,
            arcadeTagBG: undefined,
            emptyCart: undefined,
            cvvHelper: undefined,
            freeClaim: undefined,
            tokenPrimary: undefined,
            tokenSecondary: undefined,
            luckyLoungeLogoWhite: undefined,
            playersClubLogoWhite: undefined,
            collectCheckLogoIcon: undefined,
            convertArrow: undefined,
            otwImage: undefined,
            otwLogo: undefined,
            ftffImage: undefined,
            ftffLogo: undefined,
            superBonusImg: undefined,
            starImg: undefined,
            shieldIcon: undefined,
            iconAlertWarning: undefined,
            claimItAll: undefined,
            quickDrawImages: undefined,
            claimItAllSecondary: undefined,
            mnlogo: undefined,
            wvLogo: undefined,
            lottoTicket: undefined,
            printNPlay: undefined
        };
    }
    set internalAssets(value) {
        this._internalAssets = value;
    }
    get internalAssets() {
        return this._internalAssets;
    }
}
const assets = new Assets();
exports.assets = assets;
//# sourceMappingURL=assets.js.map